const { $ } = window;

const CompareUtil = {};

CompareUtil.setAddress = (page, cars, types, engs, useReplace = false) => {
  let v = (page === 'select') ? '' : 'result/';
  if (cars) v += `?cars=${cars.join(',')}`;
  if (types) v += `&types=${types.join(',')}`;
  if (engs) v += `&engs=${engs.join(',')}`;
  if (useReplace) {
    window.location.replace(`${$.address.baseURL()}#/${v}`);
  } else {
    $.address.value(v);
  }
};
CompareUtil.parseAddress = () => {
  const page = ($.address.pathNames().indexOf('result') === -1) ? 'select' : 'result';
  const cars = ($.address.parameter('cars')) ? $.address.parameter('cars').split(',') : [];
  const types = ($.address.parameter('types')) ? $.address.parameter('types').split(',') : [];
  const engs = ($.address.parameter('engs')) ? $.address.parameter('engs').split(',') : [];
  return {
    page,
    cars,
    types,
    engs,
  };
};

CompareUtil.getCarByTitle = (list, title) => {
  for (let index = 0; index < list.length; index += 1) {
    const element = list[index];
    if (element.TITLE2 === title) {
      return element;
    }
  }

  return null;
};

export default CompareUtil;
